import { connect } from 'react-redux'
import TestView from '../components/TestView'
import {
  runCommunicationsTest,
  runStageTest,
  runLinacMoveTest,
  refreshDeviceData,
  pushTestData
} from '../../../store/deviceHistory'

const mapDispatchToProps = {
  runCommunicationsTest,
  runStageTest,
  runLinacMoveTest,
  refreshDeviceData,
  pushTestData
}

const mapStateToProps = (state, ownProps) => {
  return {
    device: state.deviceHistory[ownProps.params.device_string],
    version: state.versions.staging.pinnedVersion
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TestView)



// WEBPACK FOOTER //
// ./src/routes/Test/containers/TestContainer.js